import EmailConfirmationPage from './EmailConfirmationPage';

export default EmailConfirmationPage;
